import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=89592c6a"
import script from "./BoxCard.vue?vue&type=script&lang=js"
export * from "./BoxCard.vue?vue&type=script&lang=js"
import style0 from "./BoxCard.vue?vue&type=style&index=0&id=89592c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports